<script>
    export let version = "";
    export let ddVersion = "";
</script>

<div class="footer">
    Unauthorized attempts to sign into this<br/>system are prohibited by law.<br/>
    Copyright 2026 KIOS Inc. All rights reserved.
    {#if version}<br/>Software {version}{/if}
    {#if ddVersion}<br/>DD {ddVersion}{/if}
</div>

<style lang="scss">
  .footer {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 175%;
    text-align: center;
    color: var(--color-background-purple);
  }
</style>